export const REDUX_STORE_HOME = 'add_google_source'
export const SOURCE_NAME = 'Google'
